<div class="content fleet">
    <div class="panel panel-flat panel-oncore">
        <div class="panel-heading">
            <div class="form-inline">
                <div class="form-group">
					<select class="form-control" data-width="100%" placeholder="Vehicle List" name="filterList" [(ngModel)]="filterList" (change)="filterChanged($event.target.value)">
						<option value="">Vehicle List</option>
						<optgroup label="Groups">
							<option *ngFor="let group of vehicleGroups">{{ group }}</option>
						</optgroup>
						<optgroup label="Vehicle Status">
							<option *ngFor="let status of vehicleStatusGroups">{{ status }}</option>
						</optgroup>
					</select>
                </div>
            </div>
        </div>
        <div class="table-responsive" id="vhcl-list">
            <!--<table id="oncore1" class="display table" #datatableElement cellspacing="0" width="100%" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger"></table>-->
			<table id="oncore1" class="display table nowrap" cellspacing="0" width="100%"></table>
        </div>
    </div>
</div>
<div class="modal fade" tabindex="-1" role="dialog" id="fieldOpt">
    <div class="modal-dialog" role="document">
        <div class="modal-content">
            <div class="modal-body pt-3">
				<div class="row mb-4">
					<div class="col-md-12">
                        <div class="form-group mb-1">
                            <label for="date_st">Chassis No.</label>
                            <input type="text" class="form-control" [(ngModel)]="chasisNo">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Dealer Name</label>
                            <input type="text" class="form-control" [(ngModel)]="dealerName">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Dealer Address</label>
                            <textarea class="form-control" [(ngModel)]="dealerAddress" cols="3"></textarea>
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Installation Date</label>
                            <input type="date" class="form-control" [(ngModel)]="installDate">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Activation Date</label>
                            <input type="date" class="form-control" [(ngModel)]="activationDate">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Expiry Date</label>
                            <input type="date" class="form-control" [(ngModel)]="expiryDate">
                        </div>
                        <div class="form-group mb-1">
                            <label for="date_st">Issue Date</label>
                            <input type="date" class="form-control" [(ngModel)]="issueDate">
                        </div>
					</div>
				</div>
                <div class="row mb-4">
					<div class="row">
						<div class="col-md-12">
						</div>
					</div>
                </div>
				<div class="row" style="display: flex;justify-content: flex-end;">
                    <button type="button"  class="btn  btn-default mr-5" (click)="cancelCert()">Cancel</button>
                    <button type="button"  class="btn  btn-primary" (click)="generateCert(certGenerateVehicle)">Save</button>
				</div>
            </div>
        </div>
    </div>
</div>
<div class="modal-backdrop fade" id="fieldOptBackdrop"></div>